export default __webpack_public_path__ + "static/media/landscape8.b9bda71f.JPG";